<template>
  <!-- eslint-disable max-len -->
  <div class="profile-drop-down-menu cursor-pointer">
    <mj-drop-down
      ref="profileDropDown"
      direction="right"
    >
      <div
        class="bg-indigo-800 w-12 h-12 border-2 border-indigo-600 rounded-full overflow-hidden"
        @click="showCollabsibleContent"
      >
        <img
          :src="`https://joeschmoe.io/api/v1/${user.name}`"
          class="object-fill"
        >
      </div>
      <template #collapsible>
        <div class="w-64 text-left bg-white text-gray-900 font-semibold rounded-lg overflow-hidden text-base shadow-lg">
          <div
            class="user-links py-1"
            @click="closeCollabsibleContent"
          >
            <span
              v-for="(item, index) in dropDownItems"
              :key="index"
              class="block px-6 py-3 leading-tight hover:bg-indigo-100"
              @click="showModal(item.modalName)"
              v-text="item.label"
            />
          </div>
          <div class="actions border-t-2 border-gray-200 py-1 ">
            <button
              class="block w-full px-6 py-3 text-left font-semibold outline-none hover:bg-indigo-100 focus:outline-none"
              @click="onLogout"
            >
              Logout
            </button>
          </div>
        </div>
      </template>
    </mj-drop-down>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import DropDown from '@/components/ui/general/dropdown/DropDown.vue';

export default {
  name: 'ProfileDropDownMenu',

  components: {
    'mj-drop-down': DropDown,
  },

  data() {
    return {
      dropDownItems: [
        { label: 'Profil bearbeiten', modalName: 'mj-profile-edit-modal' },
        { label: 'Passwort ändern', modalName: 'mj-profile-change-password-modal' },
      ],
    };
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    ...mapActions(['logout']),

    showCollabsibleContent() {
      this.$refs.profileDropDown.$data.isOpen = true;
    },

    closeCollabsibleContent() {
      this.$refs.profileDropDown.$data.isOpen = false;
    },

    showModal(name) {
      this.$modal.show('root-modal', { name });
      this.closeCollabsibleContent();
    },

    onLogout() {
      this.logout();
      this.$router.push({ name: 'login' });
    },
  },

};

</script>
